import FilterCheckboxLabel from './FilterCheckboxLabel';
export default FilterCheckboxLabel;